import { Backdrop, Box, CircularProgress } from "@mui/material";
import React from "react";

export default function Loading() {
	return (
		<Backdrop
			sx={{
				backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        color: "#fff"
			}}
			open={true}
		>
			<Box
				sx={{
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
				}}
			>
				<CircularProgress color="inherit" />
			</Box>
		</Backdrop>
	);
}
